import { ConfiguratorAction, ConfiguratorActionEnum } from "helpers/context/Configurator/ConfiguratorContext";
import { IBearerToken } from "helpers/interfaces";
import { CaseInsensitiveCompare } from "helpers/objects";

export default class ConfiguratorHandler {

    #dispatch: React.Dispatch<ConfiguratorAction>;

    constructor(dispatch: React.Dispatch<ConfiguratorAction>) {
        this.#dispatch = dispatch;
    }

    private SetEmbedded = () => {
        this.#dispatch({ action: ConfiguratorActionEnum.SetEmbedded, value: true });
    }

    private SetConfigurator = (configurator: string) => {
        this.#dispatch({ action: ConfiguratorActionEnum.SetConfigurator, value: configurator });
    }

    private SetIntegrationKeyInternal = (integrationKey: string) => {
        this.#dispatch({ action: ConfiguratorActionEnum.SetIntegrationKey, value: integrationKey });
    }

    public SetInstanceIsEmbedded() {
        this.SetEmbedded();
    }

    public SetConfiguratorMode(configurator: string) {
        this.SetConfigurator(configurator);
    }

    public SetIntegrationKey(integrationKey: string) {
        this.SetIntegrationKeyInternal(integrationKey);
    }

    public PostLoginSuccess(configurator: string) {
        if (window.parent !== null) {
            if (CaseInsensitiveCompare(configurator, "ShellTest")) {
                window.parent.postMessage({
                    type: "login-success"
                }, "*");
            }
            if (CaseInsensitiveCompare(configurator, "OCC")) {
                window.parent.postMessage({
                    type: "login-success"
                }, "*");
            }
        }
    }

    public PostTokenLoginSuccess(configurator: string, token: IBearerToken) {
        if (window.parent !== null) {
            if (CaseInsensitiveCompare(configurator, "ShellTest")) {
                window.parent.postMessage({
                    type: "token-login-success",
                    message: token
                }, "*");
            }
            if (CaseInsensitiveCompare(configurator, "OCC")) {
                window.parent.postMessage({
                    type: "token-login-success",
                    message: token
                }, "*");
            }
        }
    }

    public PostProductNavigatorCancel(configurator: string) {
        if (window.parent !== null) {
            if (CaseInsensitiveCompare(configurator, "ShellTest")) {
                window.parent.postMessage({
                    type: "prodnav-cancel",
                    message: "cancel"
                }, "*");
            }
            if (CaseInsensitiveCompare(configurator, "OCC")) {
                window.parent.postMessage({
                    type: "prodnav-cancel",
                    message: "cancel"
                }, "*");
            }
        }
    }

    public PostOptionsWizardCancel(configurator: string) {
        if (window.parent !== null) {
            if (CaseInsensitiveCompare(configurator, "ShellTest")) {
                window.parent.postMessage({
                    type: "wizard-cancel",
                    message: "cancel"
                }, "*");
            }
            if (CaseInsensitiveCompare(configurator, "OCC")) {
                window.parent.postMessage({
                    type: "wizard-cancel",
                    message: "cancel"
                }, "*");
            }
        }
    }

    public PostOptionsWizardSave(configurator: string, odKey: number) {
        if (window.parent !== null) {
            if (CaseInsensitiveCompare(configurator, "ShellTest")) {
                window.parent.postMessage({
                    type: "wizard-save",
                    message: odKey
                }, "*");
            }
            if (CaseInsensitiveCompare(configurator, "OCC")) {
                window.parent.postMessage({
                    type: "wizard-save",
                    message: odKey
                }, "*");
            }
        }
    }

};


